// src/pages/hr/HRComingSoon.jsx
// Reusable Coming Soon shell for HR module pages not yet implemented
import React from "react";
import { HR_NAV } from "../../utils/navigation";
import Layout from "../../components/common/Layout";

const PANEL_LABEL = "HR Panel";

export default function HRComingSoon({ icon = "🚧", title = "Module", description = "This module is under development." }) {
  return (
    <Layout navItems={HR_NAV} panelLabel={PANEL_LABEL}>
      <style>{`
        .cs-wrap { display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 60vh; text-align: center; gap: 1rem; }
        .cs-icon { font-size: 5rem; }
        .cs-title { font-size: 1.75rem; font-weight: 800; color: var(--text-primary, #111); }
        .cs-desc { font-size: 0.95rem; color: var(--text-muted, #6b7280); max-width: 420px; }
        .cs-badge { display: inline-block; background: linear-gradient(135deg, #1b4b31, #3da068); color: #fff; padding: 0.45rem 1.2rem; border-radius: 99px; font-size: 0.82rem; font-weight: 700; }
        .cs-modules { display: grid; grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 1rem; margin-top: 1.5rem; width: 100%; max-width: 700px; }
        .cs-module-card { background: var(--bg-card, #fff); border: 1px solid var(--border, #e5e7eb); border-radius: 10px; padding: 1.25rem 1rem; text-align: center; box-shadow: 0 1px 5px rgba(0,0,0,0.06); }
        .cs-module-icon { font-size: 1.8rem; margin-bottom: 0.5rem; }
        .cs-module-label { font-size: 0.82rem; font-weight: 600; color: var(--text-primary, #111); }
      `}</style>
      <div className="page-header">
        <div>
          <h1 className="page-title">{title}</h1>
        </div>
      </div>
      <div className="cs-wrap">
        <div className="cs-icon">{icon}</div>
        <div className="cs-title">{title}</div>
        <div className="cs-desc">{description}</div>
        <div className="cs-badge">🚀 Coming Soon</div>
      </div>
    </Layout>
  );
}
